import React from "react"
import styled from "styled-components"
import {FormattedMessage} from "@irati/utils/lang"
import {Body} from "@irati/ui/src/Typography"

const StyledBody = styled(Body)`
  background: ${({theme}) => theme.colors.greys.light};
  border-radius: ${({theme}) => theme.spacing.one}
`

export const CustomStatus = (({errorMsg}: {
  errorMsg: string
}) => {
  return (
    <StyledBody wordBreak="break-word" padding={[1, 2]}>
      <FormattedMessage id={errorMsg} />
    </StyledBody>
  )
})
